import { inject, InjectionToken } from "@angular/core";
import { AuthFeatures } from "src/app/services/auth.service";
import { ProductService } from "src/app/services/product.service";
import { SoftwareProduct } from "src/app/support/product";

export const AUTH_FEATURES = new InjectionToken<AuthFeatures>("auth_features", {
  providedIn: "root",
  factory: () => {
    switch (inject(ProductService).getCurrentProduct()) {
      case SoftwareProduct.PMS:
      case SoftwareProduct.ROCKET:
      case SoftwareProduct.SNOOTS:
      case SoftwareProduct.ADMIN:
      case SoftwareProduct.DROP_PAGE:
      case SoftwareProduct.BOTMASTER: {
        return {};
      }
      case SoftwareProduct.PLATFORM: {
        return {
          enableSignup: true
        };
      }
      default: {
        return {};
      }
    }
  }
});
